import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { ProjectImageSlot } from './ProjectImageSlot';
import { StatusBadge } from './StatusBadge';
import type { LatestProject } from '../../types/latestProjects';
import { latestCategoryLabel, latestProjectDates, publicValues } from '../../utils/latestProjects';
interface LatestProjectCardProps {
  project: LatestProject;
  onView: (id: string) => void;
}
export function LatestProjectCard({
  project,
  onView
}: LatestProjectCardProps) {
  const rows: [string, string][] = [['Location', project.location], ...(project.clientApproved && project.client ? [['Client', project.client] as [string, string]] : []), ...latestProjectDates(project), ...publicValues(project).map(v => [v.label, v.amount] as [string, string])];
  return <article className="flex flex-col bg-charcoal-850 ring-1 ring-white/10" data-id="element-238" data-mp="u0bc8wtpkkhk">
      <ProjectImageSlot src={project.imageUrl} alt={project.imageAlt} data-id="element-239" data-mp="p186191zs880" />
      <div className="flex flex-1 flex-col p-5 sm:p-6" data-id="element-240" data-mp="p31dgqkfiwh2">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-2" data-id="element-241" data-mp="18p27rmr1j1xg">
          <StatusBadge status={project.status} data-id="element-242" data-mp="1cpcex2qkjydw" />
          <span className="font-display text-[13px] font-bold uppercase tracking-[0.14em] text-brand-light" data-id="element-243" data-mp="1cp2ndapvlj63">
            {latestCategoryLabel(project.category)}
          </span>
        </div>
        <h3 className="mt-3 font-display text-[24px] font-extrabold uppercase leading-[1.02] text-white sm:text-[26px]" data-id="element-244" data-mp="13nctly8iu855">
          {project.title}
        </h3>
        <dl className="mt-4 space-y-1.5 text-[14px]" data-id="element-245" data-mp="tr9smvpeofjs">
          {rows.map(([label, value]) => <div key={label} className="grid grid-cols-[130px_1fr] gap-3" data-id="element-246" data-mp="fzva0pzeugd9">
              <dt className="font-semibold uppercase tracking-[0.08em] text-steel-400 text-[12px] leading-[1.6]" data-id="element-247" data-mp="fxil1sv8j5qp">{label}</dt>
              <dd className="text-steel-100" data-id="element-248" data-mp="60nm58v1v3bw">{value}</dd>
            </div>)}
        </dl>
        <p className="mt-4 text-[15px] leading-relaxed text-steel-200" data-id="element-249" data-mp="b0s3f13s8236">{project.scope}</p>
        <button id={`latest-view-${project.id}`} type="button" onClick={() => onView(project.id)} aria-label={`View project: ${project.title}`} className="group mt-5 inline-flex items-center gap-2 self-start py-1 font-display text-[15px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-150 hover:text-brand-light" data-id="element-250" data-mp="3o0rkkrlzyu98">
          View project
          <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-251" data-mp="atgd8hjcwykx" />
        </button>
      </div>
    </article>;
}